<nb-card>
  <nb-card-header>
      <span i18n="@@AdditionalCategoriesHeader">
        Дополнительные категории
      </span>

    <app-choose-catalog-input (removeCatalogEvent)="onRemoveAdditionalCatalogFromModal($event)"
                              (catalogChosenEvent)="onCatalogSelected($event)"
                              [onlyOneSelection]="false"
                              [chooseOnlyLastLevel]="true"
                              *ngIf="canEdit"
                              [chosenCatalogs]="catalogs || []"
                              [excludeCatalogIds]="excludeCatalogIds"/>
  </nb-card-header>

  <nb-card-body>
    <p *ngIf="!canEdit">Сохраните товар перед редактированием дополнительных категорий</p>
    <ng-container *ngIf="catalogs?.length">
      <nb-tag-list>
        <nb-tag appearance="outline" status="primary" *ngFor="let catalog of catalogs" [text]="catalog.header" [removable]="true" (remove)="removeAdditionalCatalog(catalog)"></nb-tag>
      </nb-tag-list>
    </ng-container>
  </nb-card-body>

</nb-card>
